import './App.scss';

import { Button, Typography } from '@trackman/web-shared-components';

import { ErrorBoundary } from 'react-error-boundary';
import Layout from 'components/Layout/Layout';
import { Outlet } from 'react-router';
import ThemeProvider from '@trackman/web-shared-components/styles/Theme';
import { useTranslation } from 'react-i18next';

export const App = () => {
  const { t } = useTranslation();

  return (
    <ThemeProvider>
      <Layout>
        <ErrorBoundary
          fallback={
            <div className='error-boundary-info'>
              <Typography component='div' variant='h1'>
                {t('Something went wrong')}
              </Typography>
              <Button intent='primary' onClick={() => window.location.reload()}>
                {t('Reload')}
              </Button>
            </div>
          }
        >
          <Outlet />
        </ErrorBoundary>
      </Layout>
    </ThemeProvider>
  );
};

export default App;
